import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import {filter, map, mergeMap} from "rxjs/operators";
import {UserService} from "src/services/user.service";
import {LogsService} from "src/services/log.service";
import {User, UserLogs} from "src/models/user.model";
import firebase from "firebase/app";
import {Logs} from "src/models/logs";
import {FormArray, FormBuilder, FormGroup} from "@angular/forms";
import {VehicleService} from "src/services/vehicle.service";
import Swal from "sweetalert2";
import {Vehicles} from "../../../../../models/vehicle.model";
import * as moment from "moment";
import {AuthService} from "../../../../../services/auth.service";
import {Account} from "../../../../../models/account.model";
import {AngularFirestore} from '@angular/fire/firestore';
import {GeotagService} from "../../../../../services/geotag.service";
import {PaymentService} from "../../../../../services/payment.service";
import {ZonesSlotService} from "../../../../../services/zones-slot.service";
import {ZoneSlotAssignment} from "../../../../../enum/enum";

interface FirestoreTimestamp {
  seconds: number;
  nanoseconds: number;
}

@Component({
  selector: 'app-vehicles-edit',
  templateUrl: './vehicles-edit.component.html',
  styleUrls: ['./vehicles-edit.component.css']
})
export class UserVehiclesEditComponent implements OnInit {

  public userForm: FormGroup;
  public vehicleForm: FormGroup;
  userVehicles: FormArray;

  date: any;

  get color(): string {
    return this._color;
  }
  set color(color: string) {
    this._color = color !== "light" && color !== "dark" ? "light" : color;
  }
  private _color = "light";

  user: UserLogs = <UserLogs> {};
  user_vehicle: any = {};
  vehicle: Vehicles = <Vehicles> {};
  logs: Logs[] = [];
  logDetailsSideBar: any = {
    time_in: null as FirestoreTimestamp | null,
    time_out: null as FirestoreTimestamp | null,
    actual_end_time: null as FirestoreTimestamp | null,
    initial_payment_recieved_date: null as FirestoreTimestamp | null,
    additional_payment_recieved_date: null as FirestoreTimestamp | null,
    // other properties...
  };
  geoTagsPhotos: any = [];
  payment: any = [];

  userLogs: any = [];

  userAuth: User;
  account: Account;
  zones: any = [];
  zone: any = {};

  searchVia = '';
  searchCode = '';

  toggleButtonConfig = {
    value: false
  }

  constructor(
    private firestore: AngularFirestore,
    protected route : ActivatedRoute,
    private userService: UserService,
    private logService: LogsService,
    private vehicleService: VehicleService,
    public formBuilder: FormBuilder,
    public router: Router,
    public auth: AuthService,
    private geotagService: GeotagService,
    private paymentService: PaymentService,
    private zoneSlotService: ZonesSlotService
    ) {

    this.auth.user$.subscribe(user => this.userAuth = user);
    this.account = JSON.parse(localStorage.getItem('account'));
    this.zones = this.account.settings.zones;

  }

  async ngOnInit() {


    this.vehicleForm = this.formBuilder.group({
      plate_number: [''],
      vehicle_type:  [''],
      vehicle_model:  [''],
      vehicle_color:  [''],
    });

    this.route.paramMap
      .pipe(
        map(pm => pm.get('id')),
        filter(id => id != null),
        mergeMap(id => {

          this.searchVia = 'plate_number';
          return this.vehicleService.getVehicleByPlateNumber(id);

       }),
      ).subscribe(async (vehicle: any) => {

      if (!vehicle) {
        return;
      }

      this.vehicle = vehicle;

      this.vehicleForm = this.formBuilder.group({
        plate_number: this.vehicle.plate_number,
        vehicle_type: this.vehicle.vehicle_type,
        vehicle_model: this.vehicle.vehicle_model,
        vehicle_color: this.vehicle.vehicle_color
      });

      this.vehicleForm.patchValue(this.vehicle);

      if (this.account.account_key && this.searchVia == 'plate_number') {

        const logRef = firebase.firestore().collection('logs');

        const snapshot = await logRef
          .where('account_key', '==', this.account.account_key)
          .where('plate_number', '==', this.vehicle.plate_number)
          .orderBy('timestamp', 'desc')
          //.limit(10)
          .get();

        await this.getLogsVia(snapshot);

      }

    },error => {
      console.log("Error :", error);
    });

  }

  // createUserVehicles(): FormGroup {
  //   return this.formBuilder.group({
  //     code: this.user.code,
  //     user_id: this.user.code,
  //     plate_number: [''],
  //     vehicle_type: [''],
  //     vehicle_model: [''],
  //     vehicle_color: [''],
  //     date_registered: [new Date()],
  //   });
  // }

  // addVehicles() {
  //   this.userVehicles.push(this.createUserVehicles());
  // }

  async getLogsVia(snapshot){

    let arrayLogs = [];
    snapshot.forEach((doc) => {


      let duration;
      let data = doc.data();

      data.id = doc.id;

      const timeIn = moment.unix(doc.data().time_in.seconds);
      let timeOut;

      if (doc.data().time_in) {
        if (doc.data().actual_end_time) {
          timeOut = moment.unix(doc.data().actual_end_time?.seconds);
        } else if (doc.data().time_out) {
          timeOut = moment.unix(doc.data().time_out?.seconds);
        } else {
          // For active sessions, use current time
          timeOut = moment();
        }
      }

      if(!timeIn) return;

      let startTime = moment(timeIn, "HH:mm:ss a");
      let endTime = moment(timeOut, "HH:mm:ss a");
      let min = moment.utc(moment(endTime, "HH:mm:ss").diff(moment(startTime, "HH:mm:ss"))).format("mm");
      let sec = moment.utc(moment(endTime, "HH:mm:ss").diff(moment(startTime, "HH:mm:ss"))).format("ss");
      let hour = endTime.diff(startTime, 'hours');

      let hourString = hour + "hr, ";
      let minString = min + "min and ";
      let secString = sec + "sec";

      if(hour === 0 && min !== "00"){
        duration = minString + secString;
      }else if(hour === 0 && min === "00"){
        duration = sec + " seconds";
      }else{
        duration = hourString + minString + secString;
      }

      data.duration = duration;

      // Set session status based on entry_status and exit_status
      if (data.status === 'cancelled') {
        data.session_status = 3; // Cancelled
      } else if (data.status === 'refunded') {
        data.session_status = 6; // Refunded
      } else if (data.entry_status && data.exit_status) {
        data.session_status = 2; // Completed
      } else if (data.entry_status && !data.exit_status) {
        data.session_status = 1; // Active
      }

      arrayLogs.push(data);

    });

    Promise.all(arrayLogs).then(async (response) => {
      this.logs = response;
      this.zone = await this.getZoneByLog();
    }).catch((e) =>{
      //Handle errors
    });

  }

  getZoneByLog(): Promise<any> {
    return new Promise((resolve, reject) => {
      const zone = this.zones.find(item => this.logs[0].zone_id === item.zone_id);
      if (zone) {
        resolve(zone);
      } else {
        reject("Zone not found for the given log.");
      }
    });
  }

  calculateActualDuration(log): Promise<any>{

    return new Promise((resolve) => {
      const timeIn = moment.unix(log.time_in.seconds);
      let timeOut;
  
      if (log.time_in) {
        if (log.actual_end_time) {
          timeOut = moment.unix(log.actual_end_time?.seconds);
        } else if (log.time_out) {
          timeOut = moment.unix(log.time_out?.seconds);
        } else {
          // Use current time if no time_out is available
          timeOut = moment();
        }
      }
  
      if(!timeIn) {
        resolve('-');
        return;
      }
      
      let duration;
  
      let startTime = moment(timeIn, "HH:mm:ss a");
      let endTime = moment(timeOut, "HH:mm:ss a");
      let min = moment.utc(moment(endTime, "HH:mm:ss").diff(moment(startTime, "HH:mm:ss"))).format("mm");
      let sec = moment.utc(moment(endTime, "HH:mm:ss").diff(moment(startTime, "HH:mm:ss"))).format("ss");
      let hour = endTime.diff(startTime, 'hours');
  
      let hourString = hour + "hr, ";
      let minString = min + "min and ";
      let secString = sec + "sec";
  
      if(hour === 0 && min !== "00"){
        duration = minString + secString;
      }else if(hour === 0 && min === "00"){
        duration = sec + " seconds";
      }else{
        duration = hourString + minString + secString;
      }
  
      resolve(duration);
    });
  }

  calculateParkingDuration(log): Promise<any>{

    return new Promise((resolve) => {
      const timeIn = moment.unix(log.time_in.seconds);
      let timeOut;
      
      if (log.time_out) {
        timeOut = moment.unix(log.time_out?.seconds);
      } else {
        // Use current time for active sessions
        timeOut = moment();
      }
  
      if(!timeIn) {
        resolve('-');
        return;
      }
  
      let duration;
  
      let startTime = moment(timeIn, "HH:mm:ss a");
      let endTime = moment(timeOut, "HH:mm:ss a");
      let hour = endTime.diff(startTime, 'hours');
  
      duration = hour + "hr/s"
  
      resolve(duration);
    });
  }

  async save(value){

    if(value){

      if(this.userForm.valid){
        await this.vehicleService.updateUsersVehicleByPlate(this.userForm.value, this.user_vehicle.plate_number).then(() =>{
          Swal.fire(
            'Success',
            'Successfully saved',
            'success'
          )

          // this.vehicleService.updateVehicle(this.vehicleForm.value, this.vehicleForm.value.plate_number).then(() =>{
          //   Swal.fire(
          //     'Success',
          //     'Successfully saved!',
          //     'success'
          //   )
          // });

        });
      }
    }else{
      if(!this.vehicleForm.value.plate_number) {
        await Swal.fire(
          'Oops',
          'Plate number is required.',
          'warning'
        )
        return;
      }

      let filteredPlateNumber = this.vehicleForm.get('plate_number').value.toUpperCase()
        .replace(/\s/g, "")
        .replace(/[^a-zA-Z0-9\-]/g, '');
      this.vehicleForm.value.plate_number = filteredPlateNumber;
    if(this.vehicle.uid === undefined){

        let vehicleDetails:any = await this.vehicleService.getVehicleByCode(this.vehicle.code)

        this.vehicle.plate_number = filteredPlateNumber;
        this.vehicle.vehicle_type = this.vehicleForm.value.vehicle_type;
        this.vehicle.vehicle_model = this.vehicleForm.value.vehicle_model;
        this.vehicle.vehicle_color = this.vehicleForm.value.vehicle_color;

            if(vehicleDetails === null){

              this.vehicle.date_registered = new Date();

              this.logService.createPlateByCode(this.vehicle).then(result => {

                this.vehicleService.createPlateByCode(this.vehicle).then(data => {

                  this.vehicleService.addVehicle(this.vehicle).then((result) =>{
                    Swal.fire(
                      'Success',
                      'Successfully saved!',
                      'success'
                    )
                  },error => {
                    console.log("Save Users Vehicle Error:",error)
                  });

                },error => {
                  console.log("2. Error:",error)
                })

              },error =>{
                console.log("3. Error:",error)
              })


            }else{

              this.vehicle.updatedAt = new Date();

              this.logService.updatePlateByCode(this.vehicle).then(result => {

                this.vehicleService.updatePlateByCode(this.vehicle).then(data => {

                  this.vehicle.id = vehicleDetails.id;

                  this.vehicleService.updateVehicleByCode(this.vehicle.code, this.vehicle).then((result) =>{
                    Swal.fire(
                      'Success',
                      'Successfully updated!',
                      'success'
                    )

                  },error => {
                    console.log("Update Users Vehicle Error:",error)
                  });

                },error=>{
                  console.log("2. updatePlateByCode:",error)

                })
              },error=>{
                console.log("3. updatePlateByCode:",error)

              })



            }


      }
    }
  }

  async delete(log: Logs){
    Swal.fire({
      title: 'Are you sure?',
      text: "You won't be able to revert this!",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!',
      cancelButtonText: 'No, keep it'
    }).then((result) => {
      if (result.isConfirmed) {
        this.logService.deleteLogs(log).then(() =>{
          const index: number = this.logs.indexOf(log);
          if (index !== -1) {
            this.logs.splice(index, 1);
            Swal.fire(
              'Deleted!',
              'Log deleted!',
              'success'
            )
          }
        });
      }
    });
  }

  completeSession(log: Logs){
    Swal.fire({
      title: 'Please confirm to complete this session',
      text: "Plate number: "+ log.plate_number +"",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Complete session',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      allowEnterKey: false
    }).then((result) => {
      if (result.isConfirmed) {

        const currentTime = new Date();
        const setDataLog: any = {
          id: log.id,
          status: 'completed',
          session_status: 2,
          exit_status: true,
          time_out: currentTime,
          updatedAt: currentTime,
          session_ended_by: this.userAuth?.displayName || "admin",
          session_ended_by_id: this.userAuth?.uid || null,
          ended_date: currentTime
        };

        // Update zone slot status if applicable
        if (log.id && log.slot_id) {
          const updateZonesSlotData = {
            status: 1,
            log_id: null,
            isExpired: false,
            allowanceTimeDuration: null,
            endTime: null,
            updatedAt: currentTime
          }

          this.zoneSlotService.getZoneSlotById(log.id, log.slot_id, this.account.account_key).then((res) =>{
            if(res){
              this.zoneSlotService.updateZonesSlot(log.slot_id, updateZonesSlotData);
            }
          });
        }

        // Update log using the mobile app pattern
        this.logService.enSessionLog(setDataLog).then((doc: any) => {
          const index: number = this.logs.indexOf(log);
          if (index !== -1) {
            // Update the local log object
            this.logs[index].status = 'completed';
            this.logs[index].session_status = 2;
            this.logs[index].exit_status = true;
            this.logs[index].updatedAt = currentTime;
            this.logs[index].session_ended_by = setDataLog.session_ended_by;
            this.logs[index].session_ended_by_id = setDataLog.session_ended_by_id;
            this.logs[index].ended_date = currentTime;
            this.logs[index].time_out = currentTime;

            Swal.fire(
              'Success',
              'Plate: '+ log.plate_number +' was successfully completed',
              'success'
            )
          }
        }).catch((error) => {
          console.error('Error completing session:', error);
          Swal.fire(
            'Error',
            'Failed to complete session. Please try again.',
            'error'
          )
        });
      }
    });
  }

  async endSession(log: Logs){
    Swal.fire({
      title: 'Please confirm to end this session',
      text: "Plate number: "+ log.plate_number +"",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'End session',
      cancelButtonText: 'Cancel',
      allowOutsideClick: false,
      allowEnterKey: false
    }).then((result) => {
      if (result.isConfirmed) {

        const currentTime = new Date();
        const setDataLog: any = {
          id: log.id,
          status: 'completed',
          session_status: 2,
          exit_status: true,
          updatedAt: currentTime,
          time_out: currentTime,
          session_ended_by: this.userAuth?.displayName || "admin",
          session_ended_by_id: this.userAuth?.uid || null,
          ended_date: currentTime
        };

        // Set end time based on zone assignment type
        //if (this.zone.zone_slot_assignment === ZoneSlotAssignment.Manual) {
          //setDataLog.actual_end_time = currentTime;
        //} else {
          //setDataLog.time_out = currentTime;
        //}

        // Update zone slot status if applicable
        if (log.id && log.slot_id) {
          const updateZonesSlotData = {
            status: 1,
            log_id: null,
            isExpired: false,
            allowanceTimeDuration: null,
            endTime: null,
            updatedAt: currentTime
          }

          this.zoneSlotService.getZoneSlotById(log.id, log.slot_id, this.account.account_key).then((res) =>{
            if(res){
              this.zoneSlotService.updateZonesSlot(log.slot_id, updateZonesSlotData);
            }
          });
        }

        // Update log using the mobile app pattern
        this.logService.enSessionLog(setDataLog).then((doc: any) => {
          const index: number = this.logs.indexOf(log);
          if (index !== -1) {
            // Update the local log object
            this.logs[index].status = 'completed';
            this.logs[index].session_status = 2;
            this.logs[index].exit_status = true;
            this.logs[index].updatedAt = currentTime;
            this.logs[index].session_ended_by = setDataLog.session_ended_by;
            this.logs[index].session_ended_by_id = setDataLog.session_ended_by_id;
            this.logs[index].ended_date = currentTime;
            this.logs[index].time_out = currentTime;

            // Set end time in local object with proper Firestore timestamp format
            const firestoreTimestamp = {
              seconds: Math.floor(currentTime.getTime() / 1000),
              nanoseconds: (currentTime.getTime() % 1000) * 1000000
            };

            this.logs[index].actual_end_time = firestoreTimestamp;

            // Recalculate duration
            this.calculateActualDuration(this.logs[index]).then((duration) => {
              this.logs[index].duration = duration;
            });

            Swal.fire(
              'Success',
              'Plate: '+ log.plate_number +' was successfully ended on '+ currentTime.toLocaleString(),
              'success'
            )
          }
        }).catch((error) => {
          console.error('Error ending session:', error);
          Swal.fire(
            'Error',
            'Failed to end session. Please try again.',
            'error'
          )
        });
      }
    });
  }

  isSidebarOpen = false;

  async openSidebar(log: any) {
    console.log(log);
    this.isSidebarOpen = true;
    this.logDetailsSideBar = log;
    this.logDetailsSideBar.actual_duration = await this.calculateActualDuration(log);
    this.logDetailsSideBar.parking_duration = await this.calculateParkingDuration(log);

    // Process "Ended By" logic with zone assignment info
    this.processEndedByDisplay();

    // get geotag images
    await this.getGeotagByLogId(log.id);
  }

  // updateLog(){
  //
  //   //TODO: recalculate amount due based on the updated actual end time
  //
  //   const data: any = {
  //     id: this.logDetailsSideBar.id,
  //     updatedAt: new Date(),
  //   };
  //
  //   if (this.logDetailsSideBar.actual_end_time) {
  //     data.actual_end_time = new Date(this.logDetailsSideBar.actual_end_time);
  //   } else if (this.logDetailsSideBar.time_out) {
  //     data.time_out = new Date(this.logDetailsSideBar.time_out);
  //   }
  //
  //   this.logService.updateLog(data).then((res) => {
  //     console.log(res);
  //   });
  // }

  closeSidebar() {
    this.isSidebarOpen = false;
  }

  async getGeotagByLogId(log_id){
    this.geotagService.getGeotagByLogId(log_id).then((res) => {
      this.geoTagsPhotos = res || [];
    });
  }

  // async getPaymentById(payment_id){
  //   this.paymentService.getPaymentById(payment_id).then((res) => {
  //     const payment = res[0];
  //     this.payment = payment || null;
  //     console.log("payment", this.payment);
  //   });
  // }

  // Process "Ended By" display with zone assignment info
  processEndedByDisplay() {
    const data = this.logDetailsSideBar;
    const isManualAssignment = this.zone?.zone_slot_assignment === ZoneSlotAssignment.Manual;

    // Handle cancelled transactions
    if (data.status === 'cancelled') {
      data.end_session_by = data.cancelled_by || 'System';
      return;
    }

    // Handle refunded transactions
    if (data.status === 'refunded') {
      data.end_session_by = data.refunded_by || 'System';
      return;
    }

    // Handle "Ended By" logic - check if ended by user or server with zone assignment info
    if (data.session_ended_by) {
      // Session ended by a user
      data.end_session_by = data.session_ended_by;
    } else if (data.being_processed_by) {
      // Session ended by server/system
      if (data.being_processed_by === 'server_background_completed') {
        data.end_session_by = 'System (Auto-completed)';
      } else if (data.being_processed_by.startsWith('server_')) {
        data.end_session_by = 'System';
      } else {
        data.end_session_by = data.being_processed_by;
      }
    } else {
      data.end_session_by = data.end_session_by || '';

      // If manual assignment, empty end_session_by, and status is completed, assume System ended it
      if (isManualAssignment && !data.end_session_by && data.status === 'completed') {
        data.end_session_by = 'System';
      }
    }

    // For active sessions (entry true, exit false), clear the end_session_by
    if (data.entry_status && !data.exit_status) {
      data.end_session_by = '';
    }
  }

  // Add this utility method to convert Firestore timestamp to date
  convertTimestampToDate(timestamp: any): Date | null {
    if (!timestamp) return null;

    // Handle Firestore timestamp format
    if (timestamp && typeof timestamp === 'object' && timestamp.seconds) {
      return new Date(timestamp.seconds * 1000);
    }

    // Handle regular Date objects
    if (timestamp instanceof Date) {
      return timestamp;
    }

    // Handle string dates
    if (typeof timestamp === 'string') {
      const date = new Date(timestamp);
      return isNaN(date.getTime()) ? null : date;
    }

    // Handle number timestamps (milliseconds)
    if (typeof timestamp === 'number') {
      return new Date(timestamp);
    }

    return null;
  }

}
